import { Link } from 'react-router-dom';
import type { MovieCollection } from '@/mocks/collections';
import { getMovieById } from '@/mocks/movies';

interface CollectionPreviewProps {
  items: MovieCollection[];
}

export default function CollectionPreview({ items }: CollectionPreviewProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {items.map((collection) => (
        <div
          key={collection.id}
          className="group rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
        >
          <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
            <img
              src={collection.cover}
              alt={`${collection.title}合集封面`}
              title={`${collection.title} - 影视资源合集`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/80 to-transparent"></div>
            <div className="absolute bottom-3 left-3 right-3">
              <span className="text-xs font-label text-accent-400">{collection.subtitle}</span>
              <h3 className="font-heading font-bold text-lg text-background-50">{collection.title}</h3>
            </div>
          </div>
          <div className="p-4">
            <p className="text-sm font-label text-foreground-600 line-clamp-2">{collection.description}</p>
            <div className="mt-3 flex items-center gap-2">
              <span className="text-xs font-label text-foreground-500">共收录 {collection.count} 部</span>
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              {collection.movieIds.map((id) => {
                const movie = getMovieById(id);
                if (!movie) return null;
                return (
                  <Link
                    key={id}
                    to={`/detail/${id}`}
                    className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {movie.title}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}